import { useRef, useEffect, useState } from "react"
import Layout from '../../Layout'
import RightContentQuickOrder from "components/QuickOrder/RightContentQuickOrder"
import AlertList from "components/Cart/AlertList"
import CartAction from "components/Cart/CartAction"
import CartSummarySidebar from "components/Cart/CartSummarySidebar"
import YouMightLike from "components/Cart/YouMightLike"

export default function Cart() {
    useEffect(() => {
        document.body.classList.add("NoneFooter");

        return () => {
            document.body.classList.remove("NoneFooter");
        };
    }, []);
    return (
        <Layout>
            <div className="MuiContainer-root styles_container__eEOzu MuiContainer-disableGutters MuiContainer-maxWidthLg mb-[32px] mobile-pb-230">
                <div className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3">
                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-sm-12 MuiGrid-grid-md-9 w-full-1199 px-1199-20-140">
                        <div className="styles_containerBreadcrumbs__K4TEO hidden-1199">
                            <nav className="MuiTypography-root MuiBreadcrumbs-root MuiTypography-body1 MuiTypography-colorTextSecondary" aria-label="breadcrumb">
                                <ol className="MuiBreadcrumbs-ol">
                                    <li className="MuiBreadcrumbs-li">
                                        <a className="styles_item_breadcrumb__eYGFd" href="/">Trang chủ</a>
                                    </li>
                                    <li aria-hidden="true" className="MuiBreadcrumbs-separator" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                                        <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                                        </svg>
                                    </li>
                                    <li className="MuiBreadcrumbs-li" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                                        <span className="styles_item_breadcrumb__eYGFd styles_last_breadcrumb__c7IQm">Giỏ Hàng</span>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-md-12">
                            <div className="styles_attentionList__cHet8">
                                <div className="styles_attentionItem__7nBC5 !mb-[12px]">
                                    <div className="styles_attentionContent__Y3b_H">
                                        <div className="styles_attentionIcon__Qctnh">
                                            <span style={{ boxSizing: 'border-box', display: 'inline-block', overflow: 'hidden', width: 'initial', height: 'initial', background: 'none', opacity: 1, border: '0px', margin: '0px', padding: '0px', position: 'relative', maxWidth: '100%' }}>
                                                <span style={{ boxSizing: 'border-box', display: 'block', width: 'initial', height: 'initial', background: 'none', opacity: 1, border: '0px', margin: '0px', padding: '0px', maxWidth: '100%' }}>
                                                    <img alt="" aria-hidden="true" src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2720%27%20height=%2720%27/%3e" style={{ display: 'block', maxWidth: '100%', width: 'initial', height: 'initial', background: 'none', opacity: 1, border: '0px', margin: '0px', padding: '0px' }} />
                                                </span>
                                                <img alt="cart alert" src="https://cdn-web-next.thuocsi.vn/images/cart/warning_icon.svg" decoding="async" data-nimg="intrinsic" style={{ position: 'absolute', inset: '0px', boxSizing: 'border-box', padding: '0px', border: 'none', margin: 'auto', display: 'block', width: '0px', height: '0px', minWidth: '100%', maxWidth: '100%', minHeight: '100%', maxHeight: '100%' }} />
                                            </span>
                                        </div>
                                        <div className="styles_attentionText__Jg6dB">1 sản phẩm có sự thay đổi về giá. Vui lòng kiểm tra lại
                                            <span role="button" className="styles_attentionLink__vUsEO ml-1"> tại đây</span>
                                        </div>
                                    </div>
                                </div>

                                <AlertList />

                                <CartAction />

                                <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-md-12">
                                    <div className="styles_notes__Li8i1">
                                        <div className="styles_note_content__qKelT">Trong trường hợp không tìm được thuốc mong muốn, quý khách vui lòng điền yêu cầu vào khung bên dưới. Chúng tôi sẽ liên hệ mua thuốc và báo giá sớm nhất có thể.</div>
                                        <textarea rows={1} name="note" className="styles_text_area__ay6bm" aria-label="Ghi chú của khách hàng" placeholder="Nhập ghi chú..." style={{ height: "64px", overflow: "hidden" }}></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <CartSummarySidebar />
                </div>
                <YouMightLike />
            </div>
        </Layout>
    )
}
